import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=f6cac282"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavItem: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/NavItem.vue').default,NavSection: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/NavSection.vue').default})
